import { h, Component } from 'preact'
import _ from './styles.sass'
import colorScale from '@root/lib/colorScale'
import { yearMeanValue, yearMin, yearMax } from '@root/lib/valuesFromStation'

import Chart from 'chart.js'

export default class YearGraph extends Component {
  generateChart = () => {
    const { station } = this.props

    Chart.defaults.global.defaultFontFamily = 'Interstate'

    const ctx = this.canvas.getContext('2d')
    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        // labels: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23 Uhr'],
        datasets: [
          {
            label: 'Tageswerte',
            data: station.properties.last12MonthsMedians,
            borderColor: 'black',
            borderWidth: 2,
            pointRadius: 0,
            fill: false,
            lineTension: 0.5
          }
        ]
      },
      options: {
        responsive: false,
        maintainAspectRatio: false,
        events: [],
        legend: {
          display: false,
          padding: 0
        },
        layout: {
          padding: {
            left: 10,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: 'month',
              stepSize: 1
            },
            gridLines: false,
            ticks: {
              maxRotation: 0,
              autoSkipPadding: 0,
              padding: 10,
              callback: (value, index, values) => {
                const date = new Date((values[index] || {}).value)
                const locale = 'de-de'
                return date.toLocaleString(locale, { month: 'short' })
              }
            }
          }],
          yAxes: [{
            scaleLabel: {
              padding: 0
            },
            gridLines: {
              drawBorder: false,
              drawTicks: true,
              tickMarkLength: 25
            },
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 200,
              padding: 25,
              labelOffset: 10,
              mirror: true,
              callback: (value, index, values) => {
                let label = '' + value
                if (index === values.length - 1) label += 'μg/m³'

                return label
              }
            },
            afterBuildTicks: (chart) => {
              const max = yearMax(this.props.station)
              chart.ticks = [
                yearMin(this.props.station),
                Math.round(yearMeanValue(this.props.station)),
                max
              ]
            }
          }]
        },
        tooltips: {
          enabled: false
        }
      }
    })
  }

  checkSize = () => {
    if (!this.container) return

    const width = this.container.clientWidth
    const height = this.container.clientHeight

    if (this.prevWidth !== width || this.prevHeight !== height) {
      this.prevWidth = width
      this.prevHeight = height
      this.chart.resize()
      this.updateGradient()
    }
  }

  updateGradient = () => {
    const height = this.chart.chartArea.bottom

    const ctx = this.canvas.getContext('2d')
    const gradientStroke = ctx.createLinearGradient(0, height, 0, height / 2)

    colorScale.colors(11).forEach((color, i) => {
      gradientStroke.addColorStop(i / 10, color)
    })

    this.chart.data.datasets[0].borderColor = gradientStroke
    this.chart.update()
  }

  componentDidUpdate () {
    const { station } = this.props

    this.chart.data.datasets[0].data = station.properties.last12MonthsMedians
    this.chart.update()
    this.chart.resize()
  }

  componentDidMount () {
    this.generateChart()
    this.intervalId = setInterval(this.checkSize, 50)
  }

  componentDidUnMount () {
    clearInterval(this.intervalId)
  }

  render () {
    return <div class={_.chartContainer} ref={container => { this.container = container }}>
      <canvas class={_.canvas} key='canvas' ref={canvas => { this.canvas = canvas }} />
    </div>
  }
}
